import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  NotificationPreferencesDto,
  UpdateNotificationPreferencesRequest
} from './notification-preferences-api.types';

@Injectable({ providedIn: 'root' })
export class NotificationPreferencesApiService {
  constructor(private readonly http: HttpClient) {}

  get(): Observable<NotificationPreferencesDto> {
    return this.http.get<NotificationPreferencesDto>('/api/users/me/notification-preferences');
  }

  update(request: UpdateNotificationPreferencesRequest): Observable<NotificationPreferencesDto> {
    return this.http.put<NotificationPreferencesDto>('/api/users/me/notification-preferences', request);
  }
}
